// src/utils/slugify.ts
export function slugify(text: string): string {
    return text
      .toString()
      .normalize("NFD") // rimuove caratteri speciali (es. accenti)
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-") // sostituisci tutto ciò che non è alfanumerico con un trattino
      .replace(/^-+|-+$/g, "");    // rimuovi i trattini iniziali e finali
  }
  